<template>
    <div class="box">

        <StatNav style="margin-bottom:15px;" />


        <div shadow="never" class="filter-form">

            <el-row :gutter="20">
                <el-col :span="6">
                    <label class="label">
                        {{ $t('date') }}
                    </label>
                    <el-date-picker
                            v-model="pickerModel"
                            :clearable="false"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :picker-options="pickerOptions" style="width: 100%">
                    </el-date-picker>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        {{ $t('status') }}
                    </label>
                    <el-select v-model="model.statuses" multiple style="width: 100%">
                        <el-option
                                v-for="item in statuses"
                                :key="item.id"
                                :label="$t(item.name)"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :span="6">
                    <el-button type="default" @click="expandedVisible=!expandedVisible" :icon="expandedVisible ? 'el-icon-more-outline' : 'el-icon-more'"></el-button>
                    <el-button type="primary" @click="fetchData()" icon="el-icon-refresh">{{ $t('refresh') }}</el-button>
                </el-col>
            </el-row>


            <el-row :gutter="20" style="margin-top:15px;" v-show="expandedVisible">
                <el-col :span="4">
                    <label class="label">
                        {{ $t('streams') }}
                    </label>
                    <el-select v-model="model.streamIDs" multiple :placeholder="$t('all')" style="width: 100%">
                        <el-option
                                v-for="item in streams"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        {{ $t('offers') }}
                    </label>
                    <el-select v-model="model.offerIDs" multiple :placeholder="$t('all')" style="width: 100%">
                        <el-option
                                v-for="item in filters.offers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        {{ $t('landings') }}
                    </label>
                    <el-select v-model="model.landingIDs" multiple :placeholder="$t('all')" style="width: 100%">
                        <el-option
                                v-for="item in landings"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        {{ $t('countries') }}
                    </label>
                    <el-select v-model="model.countryIDs" multiple :placeholder="$t('all')" style="width: 100%">
                        <el-option
                                v-for="item in filters.countries"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            <span class="m-r-xs flag-icon" :class="'flag-icon-' + item.id | lowercase"></span> {{item.name}}
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        {{ $t('device_type') }}
                    </label>
                    <el-select v-model="model.deviceTypeIDs" multiple :placeholder="$t('all')" style="width: 100%">
                        <el-option
                                v-for="item in filters.deviceTypes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top:15px;" v-show="expandedVisible">
                <el-col :span="4">
                    <label class="label">
                        Source
                    </label>
                    <el-input v-model="model.source"></el-input>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        Sub ID 1
                    </label>
                    <el-input v-model="model.sub1"></el-input>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        Sub ID 2
                    </label>
                    <el-input v-model="model.sub2"></el-input>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        Sub ID 3
                    </label>
                    <el-input v-model="model.sub3"></el-input>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        Sub ID 4
                    </label>
                    <el-input v-model="model.sub4"></el-input>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        Sub ID 5
                    </label>
                    <el-input v-model="model.sub4"></el-input>
                </el-col>
            </el-row>

        </div>

        <el-table
                v-loading="loading"
                :data="data.data"
                style="width: 100%">
            <el-table-column
                    type="expand">
                <template slot-scope="props">
                    <p>{{ $t('landing') }}: {{ props.row.landing.name }}</p>
                    <p>{{ $t('prelanding') }}: {{ props.row.prelanding.name }}</p>
                    <p>{{ $t('stream') }}: {{ props.row.stream.name }}</p>
                    <p>Source: {{ props.row.source }}</p>
                    <p>Sub ID 1: {{ props.row.sub1 }}</p>
                    <p>Sub ID 2: {{ props.row.sub2 }}</p>
                    <p>Sub ID 3: {{ props.row.sub3 }}</p>
                    <p>Sub ID 4: {{ props.row.sub4 }}</p>
                    <p>Sub ID 5: {{ props.row.sub5 }}</p>
                    <p>Custom click ID: {{ props.row.custom_click_id || '-' }}</p>
                    <p>User Agent: {{ props.row.user_agent }}</p>
                    <p>Referrer: {{ props.row.referrer || '-' }}</p>
                    <p>IP: {{ props.row.ip }}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="event_time"
                    :label="$t('date')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i> {{scope.row.event_time}}
                </template>
            </el-table-column>

            <el-table-column
                    prop="offer"
                    :label="$t('offer')">
                <template slot-scope="scope">
                    <router-link :to="{name: 'offer-view', params: { id: scope.row.offer.id }}">
                        {{scope.row.offer.name}}
                    </router-link>
                </template>
            </el-table-column>

            <el-table-column
                    prop="country"
                    :label="$t('country')">
                <template slot-scope="scope">
                    <span class="m-r-xs flag-icon" :class="'flag-icon-' + scope.row.country.id | lowercase"></span> {{ scope.row.country.name }}
                </template>
            </el-table-column>


            <el-table-column
                    :label="$t('device')">
                <template slot-scope="scope">
                    <div>{{ $t('device_types.' + scope.row.device_type) }}</div>
                    <div style="font-size: 11px; color: #898989">{{ scope.row.device_os }} ({{ scope.row.browser }})</div>
                </template>
            </el-table-column>

            <el-table-column
                    prop="status"
                    :label="$t('status')">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status==='approved'" disable-transitions>{{ $t('conversion_statuses.approved') }}</el-tag>
                    <el-tag type="success" v-if="scope.row.status==='hold'" disable-transitions>{{ $t('hold_date_expire', {value: scope.row.hold_date_expire}) }}</el-tag>
                    <el-tag type="warning" v-if="scope.row.status==='pending'" disable-transitions>{{ $t('conversion_statuses.pending') }}</el-tag>
                    <el-tag type="danger" v-if="scope.row.status==='rejected'" disable-transitions>{{ $t('conversion_statuses.rejected') }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                    prop="payouts"
                    :label="$t('income')">
                <template slot-scope="scope">
                    {{ scope.row.payouts | n(2, scope.row.currency.symbol) }}
                </template>
            </el-table-column>

            <el-table-column
                    prop="goal"
                    :label="$t('goal')">
                <template slot-scope="scope">
                    {{ scope.row.goal.name || '-' }}
                </template>
            </el-table-column>

            <!--<el-table-column-->
                    <!--prop="comment"-->
                    <!--:label="$t('comment')">-->
                <!--<template slot-scope="scope">-->
                    <!--{{ scope.row.comment || '-' }}-->
                <!--</template>-->
            <!--</el-table-column>-->

        </el-table>

        <div style="margin-top: 10px; text-align: center" v-if="moreVisible">
            <el-button round @click="more" :loading="loading_next">загрузить еще данные</el-button>
        </div>
    </div>
</template>

<script>
    import StatisticFilters from '../mixins/StatisticFilters'
    import PickerOptions from '../mixins/PickerOptions'
    import StatNav from '../components/StatNav'
    import qs from 'qs'

    export default {
        name: "Conversion",
        mixins: [
            PickerOptions,
            StatisticFilters
        ],
        components: {
            StatNav
        },
        data () {
            return {
                expandedVisible: false,
                loading: false,
                loading_next: false,
                next: 0,
                data: {
                    data: [],
                    _meta: {},
                    _info: {}
                },
                model: {
                    fromDate: null,
                    untilDate: null,
                    streamIDs: [],
                    offerIDs: []
                },
                order: 'event_time',
                orderDirection: 'desc',
                statuses: [
                    {id: 'approved', name: 'conversion_statuses.approved'},
                    {id: 'pending', name: 'conversion_statuses.pending'},
                    {id: 'rejected', name: 'conversion_statuses.rejected'},
                    {id: 'hold', name: 'conversion_statuses.hold'},
                ],

                dev: {}
            }
        },
        created () {
            this.$parent.title='conversions';


        },
        watch: {
            model: {
                handler () {
                    this.fetchData();
                },
                deep: true
            }
        },
        computed: {
            moreVisible () {
                return this.data._meta.count!==this.data._meta.countAll && this.data._meta.count===this.data._meta.limit
            }
        },
        methods: {
            fetchData () {
                this.next = 0;
                this.loading = true;
                this.$axios.get('/stat/conversions?' + qs.stringify({ sort: (this.orderDirection === 'desc' ? '-' : '') + this.order, c: this.model }, { encode: false })).then((res) => {
                    this.loading = false;
                    this.data = res.data
                    //this.dev = res.data.dev;
                })
            },
            more () {
                this.next+=this.data._meta.limit;
                this.loading_next = true;
                this.$axios.get('/stat/conversions?' + qs.stringify({ sort: (this.orderDirection === 'desc' ? '-' : '') + this.order, c: this.model, next: this.next }, { encode: false })).then((res) => {
                    this.data._meta = res.data._meta;
                    res.data.data.map(item => {
                        this.data.data.push(item);
                    });
                    this.loading_next = false;
                }).catch(() => {

                });
            }
        }
    }
</script>

<style lang="scss" scoped>

    .status-approved {
        white-space: pre;
        color: #4AAE51;
    }

    .status-hold {
        white-space: pre;
        color: #4AAE51;
    }

    .status-rejected {
        white-space: pre;
        color: #ff0000;
    }

    .status-pending {
        white-space: pre;
        color: #ffab00;
    }


</style>